import { css } from "@emotion/core";
import { color, fontTypes, fontSizes } from "../../constants/commons";
import { CustomButtonColor } from "./interface";

export const customButtonStyles = (
  colorType: CustomButtonColor | "disabled"
) => css`
  text-transform: uppercase;
  font-family: ${fontTypes.bold};
  font-size: ${fontSizes.sm};
  letter-spacing: 0px;
  text-align: center;
  box-shadow: ${color.buttonShadow};
  border: none;
  outline: none !important;
  border-radius: 1.56em;
  padding: 0.48em 2em;

  ${colorType === CustomButtonColor.DEFAULT &&
  `
    background: ${color.white};
    color: ${color.red};
    cursor: pointer;
  `}

  ${colorType === CustomButtonColor.PRIMARY &&
  `
    background: ${color.red};
    color: ${color.white};
    cursor: pointer;
  `}

  ${colorType === CustomButtonColor.SECONDARY &&
  `
    background: none;
    color: ${color.red};
    cursor: pointer;
    box-shadow: none;
  `}

  ${colorType === "disabled" &&
  `
    background: ${color.whitishGray};
    color: ${color.lightishGray};
    cursor: not-allowed;
  `}
`;
